import { render, staticRenderFns } from "./Scene12.vue?vue&type=template&id=2e639f48&"
import script from "./Scene12.vue?vue&type=script&lang=js&"
export * from "./Scene12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports